var _defs, _g, _path, _g2, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeating(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 1720 1989",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    id: "svg131",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs135"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Draft-1",
    transform: "matrix(0.829192,0,0,1.09268,0,-1257.05)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 1150.4301,
    width: 2073.3101,
    height: 1819.53,
    style: {
      display: "none",
      fill: "#ffffff"
    },
    id: "rect41"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Layer1",
    transform: "matrix(1.20599,0,0,0.915179,-457.841,170.765)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1.09979,0,0,1.09979,307.054,955.528)",
    id: "g45"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M829.25,1461.08C138.205,1186.43 859.587,902.998 817.51,445.751C1101.37,610.172 971.937,812.613 971.937,812.613C971.937,812.613 1066.75,709.915 1099.07,735.523C1008.41,967.17 1416.77,1267.33 898.03,1464.63C1262.6,1232.26 817.128,1129.63 882.407,914.82C767.607,939.49 727.43,1232.27 768.251,1273.1C745.204,1277.53 708.775,1231.13 708.32,1200.06C671.562,1300.28 694.536,1378.02 829.25,1461.08Z",
    style: {
      stroke: "black",
      strokeWidth: "2.81px"
    },
    id: "path43"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,379.639,1070.46)",
    id: "g49"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M756.144,1449.45C756.144,1449.45 526.593,1370.61 537.826,1147.18C570.488,1318.28 695.767,1421.33 756.144,1449.45Z",
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: 1
    },
    id: "path47"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,379.639,1070.46)",
    id: "g53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M957.013,1478.48C957.013,1478.48 1162.54,1399.22 1107.85,1205.78C1073.51,1084.35 1094.78,1070.01 1118.59,973.597C1119.17,971.21 1122.73,971.09 1124.83,970.04C1101.61,1182.5 1346.58,1256.66 957.013,1478.48Z",
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: 1
    },
    id: "path51"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,379.639,1070.46)",
    id: "g57"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M618.346,1292.24C618.346,1292.24 653.464,1396.88 781.057,1460.8C719.407,1414.3 691.971,1353.41 686.494,1301.99C682.041,1349.34 683.119,1362.56 618.346,1292.24Z",
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: 1
    },
    id: "path55"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,383.895,1072.17)",
    id: "g61"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1128.08,696.722C1128.08,696.722 1059.98,763.544 1082.54,812.916C1105.09,862.288 1118.29,948.263 1121.27,948.689C1124.25,949.114 1122.54,859.734 1114.88,832.069C1107.22,804.404 1097.43,738.007 1128.08,696.722Z",
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: 1
    },
    id: "path59"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,379.639,1070.46)",
    id: "g65"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1132.33,698.425C1132.33,698.425 1068.36,739.56 1052.43,847.853C1045.4,791.052 1047.09,781.417 1047.09,781.417C1047.09,781.417 1052.49,713.947 1132.33,698.425Z",
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: 1
    },
    id: "path63"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,379.639,1070.46)",
    id: "g69"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M834.394,387.694C834.394,387.694 845.975,415.042 850.105,422.245C1034.11,743.114 948.354,777.972 929.858,847.853C944.428,820.557 1018.69,749.95 1006.88,652.477C993.97,545.888 946.821,449.623 883.152,421.49C882.492,421.199 881.843,420.901 881.204,420.599C855.629,417.995 861.745,406.92 834.394,387.694Z",
    style: {
      fill: "white",
      stroke: "black",
      strokeWidth: 1
    },
    id: "path67"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,379.639,1070.46)",
    id: "g73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M834.394,387.694C834.394,387.694 916.099,495.571 925.433,510.436C921.272,484.162 879.108,412.601 879.108,412.601L834.394,387.694Z",
    style: {
      stroke: "black",
      strokeWidth: 1
    },
    id: "path71"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,379.639,1070.46)",
    id: "g79"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M730.149,741.419C730.149,741.419 855.467,579.479 885.795,624.113C916.123,668.746 905.993,506.806 868.056,466.178C830.12,425.55 840.589,449.065 840.589,449.065C813.826,620.634 770.109,667.171 730.149,741.419Z",
    id: "path75"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M730.149,741.419C730.149,741.419 855.467,579.479 885.795,624.113C916.123,668.746 905.993,506.806 868.056,466.178C830.12,425.55 840.589,449.065 840.589,449.065C813.826,620.634 770.109,667.171 730.149,741.419ZM847.337,456.806C851.253,460.323 856.382,465.22 862.297,471.556C870.758,480.617 877.518,496.276 882.84,514.113C891.21,542.164 895.694,575.595 895.699,599.504C895.701,608.877 895.235,616.637 893.761,621.562C893.257,620.972 892.749,620.327 892.313,619.684C885.893,610.237 876.577,607.042 865.174,608.957C856.201,610.464 845.597,615.576 834.354,623.263C816.131,635.721 795.823,655.061 777.641,674.258L777.642,674.258C804.181,626.196 829.359,568.183 847.337,456.806Z",
    id: "path77"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,379.639,1070.46)",
    id: "g85"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M712.41,1123.9C712.41,1123.9 717.887,1233.43 750.746,1266.29C738.797,1188.62 745.768,1125.02 782.61,979.019C740.789,1105.35 728.84,1207.04 712.41,1123.9Z",
    style: {
      fill: "white"
    },
    id: "path81"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M712.41,1123.9C712.41,1123.9 717.887,1233.43 750.746,1266.29C738.797,1188.62 745.768,1125.02 782.61,979.019C740.789,1105.35 728.84,1207.04 712.41,1123.9ZM724.043,1161.99C726.725,1162.14 729.509,1161.3 732.238,1158.97C734.437,1157.09 736.917,1153.64 739.307,1148.55C739.802,1147.5 740.304,1146.35 740.813,1145.12C737.298,1175.72 736.68,1202.15 738.504,1228.31C735.448,1219.47 732.906,1209.87 730.745,1200.25C727.778,1187.03 725.609,1173.73 724.043,1161.99Z",
    style: {
      fill: "white"
    },
    id: "path83"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,379.639,1070.46)",
    id: "g91"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1005.77,1183.28C1113.73,1341.6 1014.67,1418.21 911.93,1488.27C1042.93,1351.66 1045.4,1281.48 1005.77,1183.28Z",
    style: {
      fill: "white"
    },
    id: "path87"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1005.77,1183.28C1059.75,1262.44 1061.97,1321.17 1037.86,1368.87C1013.75,1416.57 963.301,1453.24 911.93,1488.27C1042.93,1351.66 1045.4,1281.48 1005.77,1183.28ZM1034.25,1253.52C1045.69,1284.98 1047.18,1312.44 1041.3,1337.02C1031.54,1377.83 1001.97,1410.38 965.588,1439.66C1011.5,1382.73 1031.71,1337.41 1035.44,1294.4C1036.63,1280.66 1036.15,1267.14 1034.25,1253.52L1034.25,1253.52Z",
    id: "path89"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,383.125,1074.39)",
    id: "g97"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M859.587,1488.27C859.587,1488.27 757.009,1441.06 795.904,1370.13C811.994,1414.76 823.741,1409.79 840.139,1416.65C868.739,1393.77 868.902,1369.59 829.244,1292.99C810.94,1289.18 941.775,1352.59 911.93,1387.67C882.085,1422.75 920,1427.77 943.097,1401.4C938.304,1451.73 911.067,1480.68 859.587,1488.27Z",
    id: "path93"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M830.822,1296.06C827.235,1293.53 826.265,1292.37 829.244,1292.99L830.822,1296.06C849.26,1309.06 936.92,1358.3 911.93,1387.67C882.085,1422.75 920,1427.77 943.097,1401.4C938.304,1451.73 911.067,1480.68 859.587,1488.27C859.587,1488.27 757.009,1441.06 795.904,1370.13C811.994,1414.76 823.741,1409.79 840.139,1416.65C868.353,1394.08 868.892,1370.24 830.822,1296.06ZM850.332,1318.05C863.477,1326.81 878.781,1337.68 890.739,1348.96C898.066,1355.87 904.105,1362.85 906.986,1369.62C908.961,1374.26 909.21,1378.71 905.929,1382.57C897.3,1392.71 893.77,1400.98 893.169,1406.92C892.548,1413.08 894.535,1417.67 897.869,1420.91C901.161,1424.1 906.168,1426.06 912.361,1425.99C917.996,1425.93 924.9,1424.09 931.868,1420.35C928.199,1434.43 922.03,1446.14 913.155,1455.42C900.825,1468.31 883.385,1476.42 860.817,1480.1L860.816,1480.1C854.527,1476.94 835.046,1466.45 818.716,1450.21C803.696,1435.27 791.185,1415.21 796.214,1391.31C802.159,1403.36 807.778,1409.85 813.21,1413.88C820.757,1419.48 828.253,1420.22 837.096,1423.92C839.755,1425.03 842.81,1424.61 845.061,1422.81C854.904,1414.93 861.66,1406.8 865.279,1397.08C868.884,1387.38 869.436,1375.98 866.136,1361.29C863.5,1349.56 858.324,1335.47 850.332,1318.05Z",
    id: "path95"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,396.153,1118.76)",
    id: "g103"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M544.026,921.746C544.026,921.746 634.371,801.285 614.942,742.997C595.513,684.71 614.942,643.908 649.915,635.165C684.887,626.422 642.143,822.657 544.026,921.746Z",
    style: {
      fill: "white"
    },
    id: "path99"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M544.026,921.746C544.026,921.746 634.371,801.285 614.942,742.997C595.513,684.71 614.942,643.908 649.915,635.165C684.887,626.422 642.143,822.657 544.026,921.746ZM651.585,642.872C620.27,650.873 604.977,688.182 622.417,740.505C626.125,751.628 626.295,764.865 623.923,779.106C640.196,738.974 650.181,700.667 653.178,673.615C654.488,661.795 654.516,652.302 652.865,646.063C652.627,645.164 652.356,644.355 652.03,643.649C651.918,643.405 651.735,643.105 651.585,642.872Z",
    id: "path101"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,379.639,1070.46)",
    id: "g109"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M901.139,911.063C901.139,911.063 846.839,975.765 868.754,1023.32C894.608,1079.43 945.226,1121.72 945.226,1121.72C945.226,1121.72 926.458,1101.4 908.973,1072.07C893.548,1046.2 879.122,1013.33 879.457,981.227C880.17,912.732 901.139,911.063 901.139,911.063Z",
    style: {
      fill: "white"
    },
    id: "path105"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M884.823,934.53C870.907,957.691 855.154,993.808 868.754,1023.32C894.608,1079.43 945.226,1121.72 945.226,1121.72C945.226,1121.72 926.458,1101.4 908.973,1072.07C893.548,1046.2 879.122,1013.33 879.457,981.227C879.68,959.775 881.89,944.877 884.823,934.53C893.323,920.377 901.139,911.063 901.139,911.063C901.139,911.063 891.248,911.85 884.823,934.53ZM871.852,990.326C870.68,1000.45 871.571,1010.61 875.911,1020.02C877.037,1022.47 878.211,1024.89 879.428,1027.27C875.465,1015.22 872.703,1002.76 871.852,990.326Z",
    style: {
      fill: "rgb(3,0,0)"
    },
    id: "path107"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,397.681,1031.5)",
    id: "g115"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1157.31,1121.72C1157.31,1121.72 1132.99,1156.32 1140.47,1187.65C1147.95,1218.98 1144.21,1298.47 1146.55,1295.67C1179.75,1231.61 1182.09,1227.87 1176.48,1194.67C1170.87,1161.47 1157.31,1121.72 1157.31,1121.72Z",
    id: "path111"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1157.31,1121.72C1157.31,1121.72 1132.99,1156.32 1140.47,1187.65C1147.95,1218.98 1144.21,1298.47 1146.55,1295.67C1179.75,1231.61 1182.09,1227.87 1176.48,1194.67C1170.87,1161.47 1157.31,1121.72 1157.31,1121.72ZM1155.25,1141.26C1159.59,1155.64 1165.49,1176.91 1168.71,1195.98C1173.14,1222.22 1171.93,1229.02 1153.35,1265.38C1153.15,1239.94 1152.59,1204.45 1148.14,1185.82C1144.32,1169.84 1149.77,1152.95 1155.25,1141.26Z",
    style: {
      fill: "rgb(3,0,0)"
    },
    id: "path113"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,379.639,1070.46)",
    id: "g121"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M794.59,1295.74C794.59,1295.74 705.401,1294.53 706.335,1248.13C707.269,1201.73 663.531,1361.6 786.185,1439.58C752.874,1386.35 713.806,1321.42 794.59,1295.74Z",
    style: {
      fill: "white"
    },
    id: "path117"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M794.59,1295.74C794.59,1295.74 705.401,1294.53 706.335,1248.13C707.269,1201.73 663.531,1361.6 786.185,1439.58C752.874,1386.35 713.806,1321.42 794.59,1295.74ZM707.377,1273.92C713.86,1281.88 723.344,1287.88 734.027,1292.23C744.144,1296.35 755.253,1298.98 765.158,1300.66L765.158,1300.66C754.55,1307.68 747.705,1315.91 743.673,1324.83C737.286,1338.96 737.856,1355.21 742.917,1372.33C746.137,1383.21 751.19,1394.5 757.125,1405.77C715.797,1362.6 707.002,1308.02 707.377,1273.92Z",
    style: {
      fill: "rgb(3,0,0)"
    },
    id: "path119"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1,0,0,1,379.639,1070.46)",
    id: "g127"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1030.12,483.969C1030.12,483.969 1097.05,623.278 1060.47,667.639C1023.89,712 1142.96,617.052 1147.63,596.039C1152.3,575.026 1137.52,600.709 1111.06,602.265C1084.6,603.822 1085.37,499.534 1030.12,483.969Z",
    style: {
      fill: "white"
    },
    id: "path123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1030.12,483.969C1030.12,483.969 1097.05,623.278 1060.47,667.639C1023.89,712 1142.96,617.052 1147.63,596.039C1152.3,575.026 1137.52,600.709 1111.06,602.265C1084.6,603.822 1085.37,499.534 1030.12,483.969ZM1047.05,502.894C1054,509.693 1059.42,518.563 1064.03,528.027C1073.12,546.681 1078.92,567.847 1085.02,583.245C1088.68,592.468 1092.62,599.804 1097,604.171C1101.3,608.453 1106.13,610.448 1111.52,610.131C1119.85,609.641 1127.15,607.042 1133.19,604.109C1127.74,610.549 1120.03,618.261 1111.5,626.154C1099.69,637.085 1086.31,648.343 1074.99,657.042C1079.67,643.291 1080.22,625.98 1077.86,607.411C1073.15,570.328 1057.5,528.07 1047.05,502.894Z",
    style: {
      fill: "rgb(3,0,0)"
    },
    id: "path125"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeating);
export default __webpack_public_path__ + "static/media/heating.86fd1b12b39146525847d7a44afab859.svg";
export { ForwardRef as ReactComponent };